export default __webpack_public_path__ + "static/media/aboutImg.8bf8771a.svg";